import axios from 'axios'
import { API_URL } from '@/api/config'
import { Loading, Message } from 'element-ui'
import { getStorage, removeStorage } from '@/hiti/Storage.js'

// 超时时间
const service = axios.create({
  baseURL: API_URL,
  timeout: 50000,
})
// http请求拦截器
let loadinginstace
service.interceptors.request.use(
  (config) => {
    // loading
    if (config.loading) {
      let target = config.target ? '[LoadingTar]' : 'body'
      loadinginstace = Loading.service({
        target: target,
      })
    }
    // token
    const token = getStorage('ACCESS-TOKEN')
    token && (config.headers.Authorization = token)
    config.headers.TenantBlock = true
    // data
    if (config.method == 'post' && !config.data) {
      config.data = {}
    }
    return config
  },
  (error) => {
    if (loadinginstace) {
      loadinginstace.close()
    }
    Message.error({
      message: error.msg,
    })
    return Promise.error(error)
  }
)

// http响应拦截器
service.interceptors.response.use(
  ({ data }) => {
    // 响应成功关闭loading
    if (loadinginstace) {
      loadinginstace.close()
    }
    if (data.code === 200) {
      return data
    } else if (data.code === 401) {
      // return data.data
      // Message.error({
      //   message: data.msg,
      // })
      removeStorage('user')
      removeStorage('userInfo')
      removeStorage('ACCESS-TOKEN')
      return Promise.reject(data.msg)
    } else {
      Message.error({
        message: data.msg,
      })
      return Promise.reject(data.msg)
    }
  },
  (error) => {
    if (loadinginstace) {
      loadinginstace.close()
    }
    Message.error({
      message: error.response.data.msg,
    })
    return Promise.reject(error)
  }
)
/**
 * get 方法
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service
      .get(url, { params: params })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.msg)
      })
  })
}

/**
 * get 方法
 */
export function post(url, data) {
  return new Promise((resolve, reject) => {
    service
      .post(url, data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.msg)
      })
  })
}
